"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeBy = exports.defaultMergeStrategy = void 0;
const defaultMergeStrategy = (left, right) => (Object.assign(Object.assign({}, left), right));
exports.defaultMergeStrategy = defaultMergeStrategy;
const mergeBy = (keyAccessor, collisionMergeStrategy = exports.defaultMergeStrategy) => (unmergedItemsRef) => {
    const unmergedItems = [...unmergedItemsRef];
    const mergedItems = new Map();
    unmergedItems.forEach((unmergedItem) => {
        const key = unmergedItem[keyAccessor];
        const mergedItem = mergedItems.get(key);
        mergedItems.set(key, !mergedItem ? unmergedItem : collisionMergeStrategy(mergedItem, unmergedItem));
    });
    return [...mergedItems.values()];
};
exports.mergeBy = mergeBy;
//# sourceMappingURL=mergeBy.js.map